import React from 'react';
import ConfirmDialog from 'dialogs/ConfirmDialog';
import { DialogProps } from '@material-ui/core';
import { IRealEstateEvent } from '../interfaces';
import { useDeleteOrRestoreRealEstateEvent } from '../hooks';

interface IProps extends DialogProps {
  realEstateEvent: IRealEstateEvent;
  onClose(): void;
  onDelete?(): void;
}

const DeleteRealEstateEventDialog = ({ realEstateEvent, onDelete, onClose, ...props }: IProps) => {
  const { deleteOrRestoreEventState, handleDeleteOrRestoreEvent } = useDeleteOrRestoreRealEstateEvent(
    realEstateEvent,
    () => {
      onClose();
      if (onDelete) onDelete();
    },
  );

  return (
    <ConfirmDialog
      {...props}
      title="Вы уверены, что хотите удалить событие?"
      disabled={deleteOrRestoreEventState.loading}
      onConfirm={handleDeleteOrRestoreEvent}
      onClose={onClose}
    />
  );
};

export default DeleteRealEstateEventDialog;
